import {
  FEATURE_NONE_OF_THE_ABOVE,
  FEATURE_ADD_OTHER,
  FEATURE_NONE_OF_THESE,
} from 'data/questionFeatures';
import { NODE_FEATURE_SUPPORT } from 'data/featuresPerQuestion';
import { OutcomeActionType } from 'utils/adl-services';
import { isQuotaFullReason } from 'components/LogicOutcome/utils';

import {
  otherSelector,
  noneOfTheAboveAnswerSelector,
} from '../SingleMultipleQuestion/utils';

import { noneOfTheseColumnSelector } from '../MatrixQuestion/utils';

export const hasOtherAnswer = ({ questionType, answers }) => {
  if (!NODE_FEATURE_SUPPORT[questionType]?.includes(FEATURE_ADD_OTHER)) {
    return false;
  }
  return Boolean(otherSelector(answers));
};

export const isNodeSupportNoneOfTheAbove = (type) =>
  NODE_FEATURE_SUPPORT[type]?.includes(FEATURE_NONE_OF_THE_ABOVE);

export const hasNoneOfTheAboveAnswer = ({ questionType, answers }) => {
  if (!isNodeSupportNoneOfTheAbove(questionType)) {
    return false;
  }

  return Boolean(noneOfTheAboveAnswerSelector(answers));
};

export const hasNoneOfTheseAnswer = ({ questionType, columns }) => {
  if (!NODE_FEATURE_SUPPORT[questionType]?.includes(FEATURE_NONE_OF_THESE)) {
    return false;
  }
  return Boolean(noneOfTheseColumnSelector(columns));
};

export const variableIcon = (action) => {
  const setOutcomes = [OutcomeActionType.Set, OutcomeActionType.Clear];
  switch (action) {
    case OutcomeActionType.Unset:
      return 'variables-disabled';
    case setOutcomes.includes(action):
    default:
      return 'variables';
  }
};

export const filterOutQuotaFromStatements = (statements) =>
  statements.filter((item) => !isQuotaFullReason(item.reason));
